<template>
  <b-modal
    id="paymentreason"
    ref="paymentreason"
    size="md"
    :no-close-on-backdrop="true"
    body-class="bg-white"
    cancel-title="close"
    cancel-variant="light"
    :ok-title-html="submitted==true?loaderIcon+'Yes':'Yes'"
    title="Payment Record"
    @ok="deletepayment"
  >
    <p>{{ reasonlist[0] }}</p>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
import store from "@/store/index";
import { notificationMixin } from "@/mixins/notification";
export default {
  props: ["PaymentDeleteDetail"],
  mixins: [notificationMixin], // for showing message notification
  name: "DeletePaymentRecord",
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // class for notification message design
    };
  },
  methods: {
    deletepayment() {
      this.submitted = true;
      store
        .dispatch(
          "invoice/deletepayment",
          JSON.stringify({ id: this.PaymentDeleteDetail.inv_pymnt_id })
        )
        .then(() => {
          this.submitted = false;
          if (
            this.$route.name == "RetainerInvoiceView" ||
            this.$route.name == "PaymentView" ||
            this.$route.name == "CustomerAdvanceView"
          ) {
            this.$emit("setAmountDetails", {
              PaymentDeleteDetail: this.PaymentDeleteDetail
            });
          }
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
             message: this.status_message,
            type: this.status_type,
            showCloseButton: true,
          });
          this.$emit("recallRecord",{
              PaymentDeleteDetail: this.PaymentDeleteDetail
            })
          // this.invoice_payment_details = this.invoice_payment_updated_details.invoice_payment_details;
          // this.invoice_amount_detail = this.invoice_payment_updated_details.invoice_amount_detail;
          // this.available_retainer = this.invoice_payment_updated_details.available_retainer;
          // this.available_credits = this.invoice_payment_updated_details.available_credits;
        });
    }
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  computed: {
    ...mapState({
      invoice_payment_updated_details: state =>
        state.invoice.invoice_payment_details,
      reasonlist: state => state.invoice.reasonlist,
      message: state => state.invoice.message,
      status_code: (state) => state.invoice.status_code,
      status_message: (state) => state.invoice.status_message,
      status_type: (state) => state.invoice.status_type,
    }),
    //  to update applied credit amount in the invoice page
    invoice_payment_details: {
      get() {
        return this.$store.state.invoice.list.invoice_payment_details;
      },
      set(val) {
        this.$store.state.invoice.list.invoice_payment_details = val;
      }
    },
    // to update balce due amount after inovice credit update
    invoice_amount_detail: {
      get() {
        return this.$store.state.invoice.list.invoice_amount_detail;
      },
      set(val) {
        this.$store.state.invoice.list.invoice_amount_detail = val;
      }
    },
    // to udpate the avialable retainer balance
    available_retainer: {
      get() {
        return this.$store.state.invoice.list.available_retainer;
      },
      set(val) {
        this.$store.state.invoice.list.available_retainer = val;
      }
    },
    // to udpate the credit details tab
    available_credits: {
      get() {
        return this.$store.state.invoice.list.available_credits;
      },
      set(val) {
        this.$store.state.invoice.list.available_credits = val;
      }
    }
  }
};
</script>

<style>
</style>
